// journalDerive.js(CommonJS, node 단위테스트에서 require) 와 공용으로 쓰기 위해 CommonJS 로 둔다.
const Decimal = require('decimal.js');

/**
 * 반올림 공통 유틸 (사사오입, ROUND_HALF_UP).
 *
 * Number.prototype.toFixed 는 이진 부동소수 값을 그대로 반올림하기 때문에
 *   (0.145).toFixed(2) === '0.14', (1.005).toFixed(2) === '1.00'
 * 처럼 5 에서 올림이 되지 않는 경우가 있다. 또한 계산 결과(1.0049999999999999 등)의
 * 부동소수 오차도 그대로 반영된다. 자리수 고정은 반드시 이 함수를 사용한다.
 *
 * - 숫자는 유효숫자 12자리로 정규화(부동소수 오차 제거) 후 Decimal 로 반올림
 * - 숫자로 해석되지 않는 값은 Number(v).toFixed 와 동일하게 'NaN' 등을 반환
 *
 * @param {number|string} value
 * @param {number} digits 소수 자리수
 * @returns {string}
 */
function toFixedHalfUp(value, digits = 0) {
	const num = Number(value);
	const d = Number.isFinite(Number(digits)) ? Math.max(0, Math.trunc(Number(digits))) : 0;
	if (!Number.isFinite(num)) return num.toFixed(d);
	const normalized = parseFloat(num.toPrecision(12));
	return new Decimal(normalized).toFixed(d, Decimal.ROUND_HALF_UP);
}

/** toFixedHalfUp 의 숫자 반환 버전 */
function roundHalfUp(value, digits = 0) {
	return Number(toFixedHalfUp(value, digits));
}

module.exports = { toFixedHalfUp, roundHalfUp };
